// extracted by mini-css-extract-plugin
export default {"title":"sba-z","warning":"tba-z","sizeOptionsLegendText":"uba-z"};